import { Component, OnInit, Input } from '@angular/core';
import { isObservable } from 'rxjs';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
import { JobPointeTransferService } from '../job-pointe-transfer/job-pointe-transfer.service';
import { JobPointePermissionsService } from 'src/app/service/auth/job-pointe-permission.service';
import { PermissionsService } from 'src/app/service/auth/permissions.service';

@Component({
  selector: 'app-manage-jobs-status',
  templateUrl: './manage-jobs-status.component.html',
  styleUrls: ['./manage-jobs-status.component.scss'],
})
export class ManageJobsStatusComponent implements OnInit {
  @Input() status: string;
  @Input() job: any;
  @Input() getData: any;
  constructor(
    private jobPointeTransferService: JobPointeTransferService,
    private toastService: ToastService,
    private permissionsService: PermissionsService,
  ) {}

  statusClassName: string;
  statusLabel: string;

  ngOnInit(): void {
    this.assignStatusClass();
  }

  assignStatusClass() {
    if (this.status == 'Active') {
      this.statusClassName = 'status-open';
    } else if (this.status == 'New Job') {
      this.statusClassName = 'status-new';
    } else if (this.status == 'Inactive') {
      this.statusClassName = 'status-closed';
    } else if (this.status == 'Hold') {
      this.statusClassName = 'status-hold';
    }
    this.statusLabel = this.status;
  }

  async updateJobStatus(newStatus) {
    if (this.status === newStatus) return;
    let result = await this.jobPointeTransferService.updateJobBoardStatus(this.job, newStatus);
    if (!isObservable(result)) return;
    result.subscribe(
      (res: any) => {
        if (res?.batchResponse.success.length) {
          this.assignStatusClass();
          this.getData();
        }
      },
      err => {
        this.toastService.showToast('Error updating job status', 'error');
      },
    );
  }

  isAllowed(resource: string, action: string) {
    const resources = {
      manage_jobs: 'manage_jobs',
    };
    const resource1 = resources[resource];
    return this.permissionsService.allow({ resource1, action });
  }
}
